
const before = (node: Element, target: Element) => {
  target.parentNode?.insertBefore(node, target);
}

export const initTitle = () => {
  const allAnchorTitle = document.querySelectorAll('*[data-menu]');
  const allAnchorItem = document.querySelectorAll('*[data-menu-item]');
  
  for (let i = 0; i < allAnchorTitle.length; i++) {
    const el = allAnchorTitle[i];
    const title = el.getAttribute('data-menu');
    const div = document.createElement("div");

    div.setAttribute('class', `supertest-menu-title title-${i + 1}`);
    div.setAttribute('data-count', `Part${i + 1}`);
    div.innerHTML = title ?? '';

    before(div, el);
  }

  for (let i = 0; i < allAnchorItem.length; i++) {
    const el = allAnchorItem[i];
    const title = el.getAttribute('data-menu-item');
    const div = document.createElement("div");

    div.setAttribute('class', 'supertest-menu-title-item');
    div.setAttribute('data-menu-sub-title', title ?? '');
    div.innerHTML = title ?? '';

    before(div, el);
  }
}  